import { defineStore } from "pinia";

export const useAppStateStore = defineStore("appState", {
  state: () => ({
    isProgressOpen: false, // 로딩 프로그레스 바
    currentLocale: "ko", // 기본 언어팩
    currentTheme: "dark", // 기본 테마
    redirectPath: "/dashboard", // 로그인 후 이동할 페이지의 url
    currentPath: "",
    rememberUser: false,
    rememberUsername: "",
    snackbar: {
      show: false,
      text: "",
      color: "#1E1E1E",
      timeout: 2000,
      location: "bottom end",
    },
  }),
  actions: {
    /* 로딩 프로그레스 관련 Actions 시작 */
    openProgress() {
      this.isProgressOpen = true;
    },
    closeProgress() {
      this.isProgressOpen = false;
    },
    /* 로딩 프로그레스 관련 Actions 끝 */

    /* 다국어 관련 Actions 시작 */
    switchLocale(locale) {
      this.currentLocale = !locale ? "ko" : locale;
    },
    /* 다국어 관련 Actions 끝 */

    /* 테마 관련 Actions 시작 */
    switchTheme(theme) {
      this.currentTheme = !theme ? "dark" : theme;
    },
    /* 테마 관련 Actions 끝 */

    /* URL 관련 Actions 시작 */
    setRedirectPath(value) {
      this.redirectPath = !value ? "/main" : value;
    },

    setCurrentPath(value) {
      this.currentPath = !value ? "" : value;
    },
    /* URL 관련 Actions 끝 */

    /* Snackbar 관련 Actions 시작 */
    openSnackbar(message, options = {}) {
      this.snackbar.title =
        options.title ?? "새로운 알림(Query)가 발생했습니다.";
      this.snackbar.text = message;
      this.snackbar.color = options.color ?? "#fff";
      this.snackbar.timeout = options.timeout ?? 2000;
      this.snackbar.location = options.location ?? "bottom end";
      this.snackbar.show = true;
      this.snackbar.clickable = options.clickable ?? true;
    },
    closeSnackbar() {
      this.snackbar.show = false;
    },
    /* Snackbar 관련 Actions 끝 */
  },

  // snackbar 는 저장하지 않는다.
  // show:true 상태가 localStorage 에 남으면 새 탭을 열 때마다
  // 부팅 직후 알림이 다시 노출된다. (pinia-plugin-persistedstate v4 기준 pick 사용)
  persist: {
    storage: localStorage,
    pick: [
      "currentLocale",
      "currentTheme",
      "redirectPath",
      "currentPath",
      "rememberUser",
      "rememberUsername",
    ],
  },
});
